<template>
  <div
    :class="{'slo-icon': true, [`size-${size}`]: size !== 'base'}"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <component :is="name" />
  </div>
</template>

<script>
import ArrowDown from '../../img/icons/arrow-down.svg';
import ArrowDownToLine from '../../img/icons/arrow-down-to-line.svg';
import ArrowDownToBracket from '../../img/icons/arrow-down-to-bracket.svg';
import ArrowLeft from '../../img/icons/arrow-left.svg';
import ArrowRight from '../../img/icons/arrow-right.svg';
import ArrowRightFromBracket from '../../img/icons/arrow-right-from-bracket.svg';
import ArrowTurnDownLeft from '../../img/icons/arrow-turn-down-left.svg';
import ArrowTurnDownRight from '../../img/icons/arrow-turn-down-right.svg';
import ArrowUpRight from '../../img/icons/arrow-up-right.svg';
import ArrowsFromLineVertical from '../../img/icons/arrows-from-line-vertical.svg';
import ArrowsRotate from '../../img/icons/arrows-rotate.svg';
import Book from '../../img/icons/book.svg';
import CaretDownSolid from '../../img/icons/caret-down-solid.svg';
import CartShopping from '../../img/icons/cart-shopping.svg';
import CCAmex from '../../img/icons/cc-amex.svg';
import CCMastercard from '../../img/icons/cc-mastercard.svg';
import CCVisa from '../../img/icons/cc-visa.svg';
import Check from '../../img/icons/check.svg';
import ChevronDown from '../../img/icons/chevron-down.svg';
import ChevronLeft from '../../img/icons/chevron-left.svg';
import ChevronRight from '../../img/icons/chevron-right.svg';
import ChevronUp from '../../img/icons/chevron-up.svg';
import CircleCheck from '../../img/icons/circle-check.svg';
import CircleCheckSolid from '../../img/icons/circle-check-solid.svg';
import CircleDashed from '../../img/icons/circle-dashed.svg';
import CircleExclamation from '../../img/icons/circle-exclamation.svg';
import CircleInfo from '../../img/icons/circle-info.svg';
import CircleMinus from '../../img/icons/circle-minus.svg';
import CirclePlaySolid from '../../img/icons/circle-play-solid.svg';
import CircleSolid from '../../img/icons/circle-solid.svg';
import CodeSimple from '../../img/icons/code-simple.svg';
import CreditCard from '../../img/icons/credit-card.svg';
import DollarSign from '../../img/icons/dollar-sign.svg';
import DropletSlash from '../../img/icons/droplet-slash.svg';
import EnvelopeCircleCheckSolid from '../../img/icons/envelope-circle-check-solid.svg';
import Expand from '../../img/icons/expand.svg';
import EyeSolid from '../../img/icons/eye-solid.svg';
import EyeSlashSolid from '../../img/icons/eye-slash-solid.svg';
import FileArrowDown from '../../img/icons/file-arrow-down.svg';
import Folder from '../../img/icons/folder.svg';
import FolderArrowDown from '../../img/icons/folder-arrow-down.svg';
import FolderOpen from '../../img/icons/folder-open.svg';
import GripVertical from '../../img/icons/grip-vertical.svg';
import Images from '../../img/icons/images.svg';
import MagnifyingGlass from '../../img/icons/magnifying-glass.svg';
import Minus from '../../img/icons/minus.svg';
import Moon from '../../img/icons/moon.svg';
import Newspaper from '../../img/icons/newspaper.svg';
import Palette from '../../img/icons/palette.svg';
import Pencil from '../../img/icons/pencil.svg';
import PipeValve from '../../img/icons/pipe-valve.svg';
import PlaySolid from '../../img/icons/play-solid.svg';
import Plug from '../../img/icons/plug.svg';
import Plus from '../../img/icons/plus.svg';
import PWTBatteryFlushometer from '../../img/icons/pwt-battery-flushometer.svg';
import PWTButton from '../../img/icons/pwt-button.svg';
import PWTController from '../../img/icons/pwt-controller.svg';
import PWTFlushometer from '../../img/icons/pwt-flushometer.svg';
import PWTManifold from '../../img/icons/pwt-manifold.svg';
import PWTShowerhead from '../../img/icons/pwt-showerhead.svg';
import PWTSoftware from '../../img/icons/pwt-software.svg';
import PWTSolenoid from '../../img/icons/pwt-solenoid.svg';
import PWTTransformer from '../../img/icons/pwt-transformer.svg';
import RulerCombined from '../../img/icons/ruler-combined.svg';
import SquareArrowUpRight from '../../img/icons/square-arrow-up-right.svg';
import TableList from '../../img/icons/table-list.svg';
import Tag from '../../img/icons/tag.svg';
import ThreeSixtySpin from '../../img/icons/360-spin.svg';
import Timer from '../../img/icons/timer.svg';
import ToiletPaperBlankUnder from '../../img/icons/toilet-paper-blank-under.svg';
import Toilet from '../../img/icons/toilet.svg';
import Trash from '../../img/icons/trash.svg';
import TriangleExclamation from '../../img/icons/triangle-exclamation.svg';
import TriangleExclamationSolid from '../../img/icons/triangle-exclamation-solid.svg';
import TriangleExclamationSolidBorder from '../../img/icons/triangle-exclamation-solid-border.svg';
import User from '../../img/icons/user.svg';
import XMark from '../../img/icons/xmark.svg';

export default {
  name: 'SloIcon',
  props: {
    name: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: 'md',
      validator: size => /^(sm|md|lg|xl|2xl)|$/.test(size.trim())
    }
  },
  components: {
    ArrowDown,
    ArrowDownToLine,
    ArrowDownToBracket,
    ArrowLeft,
    ArrowRight,
    ArrowRightFromBracket,
    ArrowTurnDownLeft,
    ArrowTurnDownRight,
    ArrowUpRight,
    ArrowsFromLineVertical,
    ArrowsRotate,
    Book,
    CaretDownSolid,
    CartShopping,
    CCAmex,
    CCMastercard,
    CCVisa,
    Check,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronUp,
    CircleCheck,
    CircleCheckSolid,
    CircleDashed,
    CircleExclamation,
    CircleInfo,
    CircleMinus,
    CirclePlaySolid,
    CircleSolid,
    CodeSimple,
    CreditCard,
    DollarSign,
    DropletSlash,
    EnvelopeCircleCheckSolid,
    Expand,
    EyeSolid,
    EyeSlashSolid,
    FileArrowDown,
    Folder,
    FolderArrowDown,
    FolderOpen,
    GripVertical,
    Images,
    MagnifyingGlass,
    Minus,
    Moon,
    Newspaper,
    Palette,
    Pencil,
    PipeValve,
    PlaySolid,
    Plug,
    Plus,
    PWTBatteryFlushometer,
    PWTButton,
    PWTController,
    PWTFlushometer,
    PWTManifold,
    PWTShowerhead,
    PWTSoftware,
    PWTSolenoid,
    PWTTransformer,
    RulerCombined,
    SquareArrowUpRight,
    TableList,
    Tag,
    ThreeSixtySpin,
    Timer,
    ToiletPaperBlankUnder,
    Toilet,
    Trash,
    TriangleExclamation,
    TriangleExclamationSolid,
    TriangleExclamationSolidBorder,
    User,
    XMark
  }
};
</script>

<style lang="scss">
@import '../../scss/variables';

.slo-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1em;
  height: 1em;
  font-size: $font-size-base;
  color: currentColor;
  vertical-align: middle;

  &.size-sm {
    font-size: $font-size-small;
  }

  &.size-md {
    font-size: $font-size-base;
  }

  &.size-lg {
    font-size: $font-size-large;
  }

  &.size-xl {
    font-size: $font-size-h2;
  }

  &.size-2xl {
    font-size: ($font-size-base * 2.975);
  }

  & > svg {
    width: 1em;
    height: 1em;
    fill: currentColor;
  }
}
</style>
